// extracted by mini-css-extract-plugin
export default {"container":"proof-sent-to-studio_container__zzDUt"};